export const projects = [
  { key: "aura", label: "Aura", sub: "Identidade Visual · Branding" },
  { key: "innovarsi", label: "Innovarsi", sub: "Identidade Visual · Editorial" },
  { key: "celiana", label: "Celiana Costa", sub: "Identidade Visual · Arquitetura" },
  { key: "roma", label: "Roma", sub: "Identidade Visual · Imobiliária" },
  { key: "livia", label: "Dra. Lívia Venâncio", sub: "Identidade Visual · Saúde" },
];

export const testimonials = [
  {
    name: "Celiana Costa",
    text: "Essa nova identidade visual conseguiu captar perfeitamente todos os elementos que eu quis, a idealização feita por vocês era o que eu precisava",
    highlight: "e vai fazer total diferença para mim.",
  },
  {
    name: "Italo Langbehn",
    text: "Obrigado pela logo meu amigo, muito bom saber que minha loja vai começar com algo exclusivo, simples",
    highlight: "e que passa a mensagem que tinha em mente para ela.",
  },
  {
    name: "Dra. Laiza Carvalho",
    text: "Quando contratei a Orlando 360, eu já tinha em mente o que queria para a minha marca, mas quando vi o projeto final, fiquei impressionada.",
    highlight: "As cores, a tipografia e os elementos são simplesmente espetaculares. Foi o melhor investimento que fiz.",
  },
  {
    name: "Miriam Marinho",
    text: "Gostaria de agradecer por todo cuidado e dedicação no desenvolvimento da minha marca. Você captou a essência do que eu queria transmitir.",
    highlight: "Trouxe cores, leveza e uma tipografia linda. Estou encantada e extremamente feliz com cada detalhe.",
  },
];
